export const convertListToSimpleObject = ({ list, idKey, nameKey }) => {
  const convertedList = {}
  list.map(element => {
    convertedList[element[idKey]] = element[nameKey]
  })
  return convertedList
}

export const convertListToSimpleArray = ({ list, idKey, nameKey }) => {
  const convertedList = []
  list.map(element => {
    convertedList.push({ [element[idKey]]: element[nameKey] })
  })
  return convertedList
}
